import { sendToApi } from 'api/client'
import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { useCurrentWorkspaceId } from 'hooks/useCurrentWorkspaceId'
import { UseMutationOptions, useMutation } from 'react-query'
import { AlmanacFileCalendarItem } from '../calendar/types'

type Props = {
  designId: string
}

type Data = AlmanacFileCalendarItem

type Variables = { media_object_ids: number[] }

type Options = Omit<UseMutationOptions<Data, unknown, Variables>, 'mutationKey' | 'mutationFn'>

const insertMediaObjects = async (workspaceId: number, designId: string, mediaObjectIds: number[]) => {
  const res = await sendToApi(`/w/${workspaceId}/designs/${designId}/insert_media_objects`, {
    method: 'POST',
    body: { media_object_ids: mediaObjectIds },
  })

  if (res.type !== SUCCESS_RESPONSE_TYPE) {
    throw new Error(res.data)
  }

  return res.data
}

export const useInsertMediaObjects = ({ designId }: Props, options?: Options) => {
  const workspaceId = useCurrentWorkspaceId()
  return useMutation<Data, Error, Variables>(
    (vars) => insertMediaObjects(workspaceId, designId, vars.media_object_ids),
    options,
  )
}
